import { observer } from "mobx-react";
import { useTranslation } from "@/i18n";
import { ProfileGeneralForm } from "@/components/profile-settings/general/profile-general-form";
import { SettingsPageShell } from "@/components/shared/settings-page-shell";

export const ProfileGeneralPage = observer(function ProfileGeneralPage({
  onDirtyChange,
}: {
  onDirtyChange?: (dirty: boolean) => void;
}) {
  const { t } = useTranslation();

  return (
    <SettingsPageShell
      title={t("profile_settings.general.title")}
      description={t("profile_settings.general.description")}
    >
      <ProfileGeneralForm onDirtyChange={onDirtyChange} />
    </SettingsPageShell>
  );
});
